import { Box, FormControl } from '@primer/react';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import Button from '../../components/ui/button';
import Modal from '../../components/ui/modal';
import ModalActions from '../../components/ui/modal/ModalActions';
import Text from '../../components/ui/text';
import TextInput from '../../components/ui/text-input';
import { useCommonContext } from '../../contexts/common';
import { ts_hocsinh_lichsu_yte_type } from '../../models/response/hoc-sinh/ts_hocsinh_lichsu_yte_type';
import { hocSinhLichSuYTeTypeApi } from '../../api/hocSinhLichSuYTeTypeApi';

interface LichSuYTeTypeDetailModalProps {
  editingData?: ts_hocsinh_lichsu_yte_type;
  onClose: () => void;
  onSuccess: () => void;
}

const LichSuYTeTypeDetailModal: React.FC<LichSuYTeTypeDetailModalProps> = ({
  editingData,
  onClose,
  onSuccess,
}) => {
  const { translate } = useCommonContext();
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm<ts_hocsinh_lichsu_yte_type>({
    defaultValues: editingData ? {
      ...editingData,
    } : {
      id: 0,
      nhom_noi_dung: "",
      nhom_noi_dung_en: "",
    }
  });

  const onSubmit = async (data: any) => {
    setIsLoading(true);
    try {
      const response = editingData
        ? await hocSinhLichSuYTeTypeApi.update({ ...data, id: editingData.id })
        : await hocSinhLichSuYTeTypeApi.insert(data);

      if (response.is_success) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error saving lich su y te type:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen
      title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
      width='small'
      onClose={onClose}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ display: "grid", gap: 2 }}>
          <FormControl>
            <FormControl.Label><Text text='Nhóm nội dung' /></FormControl.Label>
            <TextInput block
              name="nhom_noi_dung"
              register={register}
              errors={errors}
              required
              validateMessage={`${translate("Base.Form.RequiredMessage")} Nhóm nội dung`}
            />
          </FormControl>

          <FormControl>
            <FormControl.Label><Text text='Nhóm nội dung (Tiếng Anh)' /></FormControl.Label>
            <TextInput block
              name="nhom_noi_dung_en"
              register={register}
              errors={errors}
            />
          </FormControl>
        </Box>

        <ModalActions>
          <Button text='Base.Label.Close' onClick={onClose} />
          <Button text='Base.Label.Update' variant='primary' type='submit'
            isLoading={isLoading}
          />
        </ModalActions>
      </form>
    </Modal>
  );
};

export default LichSuYTeTypeDetailModal;
